// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1e41172b","453":"5a6a1014","732":"67b52bbb","977":"1ba9dba7"}[chunkId] + ".chunk.js";
};